import React, { ReactNode } from 'react';
import { Button } from 'antd';
import styles from './COButton.module.scss';
import { ButtonType, ButtonSize, ButtonHTMLType } from 'enums/ButtonEnums';

export interface Props {
  children?: ReactNode;
  onClick?: React.MouseEventHandler<HTMLElement>;
  type?:
    | ButtonType.DEFAULT
    | ButtonType.PRIMARY
    | ButtonType.LINK
    | ButtonType.TEXT;
  color?: string;
  cancelForm?: boolean;
  size?: ButtonSize.LARGE | ButtonSize.MEDIUM | ButtonSize.SMALL;
  disabled?: boolean | null;
  icon?: ReactNode;
  primary?: boolean;
  secondary?: boolean;
  text?: boolean;
  extraIcon?: ReactNode;
  block?: boolean;
  submit?: boolean;
  loading?: boolean;
  danger?: boolean;
}
/* 
  variations handled by COButton component:
  - primary button
  - secondary button
  - text button
  - only Icon button
  - disabled button
  - button with two icons
  - size of the button
*/
const COButton: React.FC<Props> = ({
  children,
  size,
  disabled,
  icon,
  secondary,
  text,
  extraIcon,
  cancelForm,
  block,
  onClick,
  submit,
  color,
  loading,
  danger,
}: Props) => {
  const currentType = text
    ? ButtonType.TEXT
    : secondary
    ? ButtonType.DEFAULT
    : ButtonType.PRIMARY;
  return (
    <div className={styles.container}>
      <Button
        loading={loading}
        onClick={onClick}
        htmlType={submit ? ButtonHTMLType.SUBMIT : ButtonHTMLType.BUTTON}
        type={currentType}
        danger={danger}
        className={`${styles.btn} ${color === 'delete' && styles.delete} ${
          cancelForm && styles.cancelForm
        }`}
        block={block}
        size={size ? size : ButtonSize.MEDIUM}
        disabled={!!disabled}
        icon={icon}>
        {children} {extraIcon}
      </Button>
    </div>
  );
};

export default COButton;
